const observer = new MutationObserver((_, obs) => {
  const subscriptionWidget = document.getElementById(
    "appstle_subscription_widget0"
  );
  const upsell = document.querySelector('lb-upsell-product-page-addon');

  if (!subscriptionWidget) return;

  const accordions = document.querySelectorAll(".product__accordion");
  const richText = document.querySelector('.product__text.richtext');
  const purchaseOptionText = subscriptionWidget.querySelector('.appstle_subscribe_save_text');
  const appstlePrice = document.querySelector('.appstle_subscription_final_price');
  let appstleParent;

  if (accordions.length > 0) {
    accordions.forEach((accordion) => {
      subscriptionWidget.insertAdjacentElement("afterend", accordion);
    });
  }

  if (upsell && richText) upsell.insertAdjacentElement("afterend", richText);

  if (purchaseOptionText) {
    appendLogo(purchaseOptionText);
  }

  if (appstlePrice) {
    appstleParent = appstlePrice.closest('.price__container');
    appstleParent.classList.add('appstle-price');
  }

  const subscriptionInput = document.getElementById('appstle_selling_plan_label_20');
  const otpInput = document.getElementById('appstle_selling_plan_label_10');

  subscriptionInput.addEventListener('change', () => {
    if (subscriptionInput.checked === true) {
      const purchaseOptionTextNew = subscriptionWidget.querySelector('.appstle_subscribe_save_text');

      appstleParent.classList.add('appstle-price');
      
      if (purchaseOptionTextNew) {
        appendLogo(purchaseOptionTextNew);
      }
    }
  });

  otpInput.addEventListener('change', () => {
    if (otpInput.checked === true) {
      appstleParent.classList.remove('appstle-price');
    }
  });

  const extraAddBtn = document.querySelector('.product-form__submit.extra__submit');
  const addBtn = document.querySelector('.product-form__submit.button--full-width');

  if (extraAddBtn && addBtn) {
    extraAddBtn.addEventListener('click', (e) => {
      addBtn.click();
    })
  }

  obs.disconnect();
});

observer.observe(document, {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true
});

const appendLogo = (toReplace) => {
  const subscriptionLogo = document.createElement('img');
  subscriptionLogo.src = 'https://cdn.shopify.com/s/files/1/0854/7686/8394/files/replenish-2.svg?v=1709149284';
  subscriptionLogo.width = 254;
  subscriptionLogo.height = 90;
  subscriptionLogo.loading = 'lazy';

  toReplace.innerHTML = '';
  toReplace.appendChild(subscriptionLogo);
}
